// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n  .IoAk-:hover {\n    color: var(--color-blue-contrast-dark);\n  }\n\n.OMJvQ {\n  text-decoration: underline !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"blueHover": "IoAk-",
	"underline": "OMJvQ"
};
export default ___CSS_LOADER_EXPORT___;
